// extracted by mini-css-extract-plugin
module.exports = {"page-body":"page-body__2s7l0","error":"error__33p0L","message":"message__11SXl","content":"content__2O4L5"};